import React from "react";
import { useAuth } from "../context/auth-context";
import AdminMyReferralsContent from "./AdminMyReferralContent";

// Mounted only under AdminLayout, so useAuth() is always safe here.
const AdminMyReferrals = () => {
  const { token, user } = useAuth();
  const userId = user?.id || user?._id;

  return <AdminMyReferralsContent token={token} userId={userId} workerType="admin" />;
};

export default AdminMyReferrals;